import BaseService from '@/services/BaseService'

class PortadorFinanceiro extends BaseService {
    constructor(){
        super('/v1/portadores-financeiro')
    }
}

export default new PortadorFinanceiro